module.exports = "pegasus/assets/x_white_icon.png";